import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./district.css";


const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";  // ⬅ Replace with base

const DistrictMaster = () => {
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const [districtName, setDistrictName] = useState("");
  const [zoneId, setZoneId] = useState("");

  const [filters, setFilters] = useState({ searchKey: "" });

  const [zones, setZones] = useState([]);       // 🔹 dropdown data
  const [districts, setDistricts] = useState([]); // 🔹 table data
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();


  const theadStyle = {

                  padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",

  }

const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};

  const fetchZones = async () => {
  try {
    setLoading(true);
const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/zoneMasterList`,
        {}, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setZones(res.data.data || []);
  } catch (err) {
    console.log("Zones Load Error:", err);

    if (err.response && (err.response.status === 401 || err.response.status === 422)) {
      localStorage.clear();
      navigate("/suda/login");
    }
  }finally {
    setLoading(false);  // ✅ STOP LOADER
  }
};



 const fetchDistricts = async (pageNo = 1, searchValue = filters.searchKey) => {
  try {
    setLoading(true);
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/districtMasterList`,
      {
        searchKey: searchValue,
        page: pageNo,
        per_page: perPage,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setDistricts(res.data.data || []);
    setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
      Math.ceil(
        (res.data.total_records || 0) /
        (res.data.per_page || perPage)
      )
    );
  } catch (err) {
    if (err.response?.status === 401) {
      localStorage.clear();
      navigate("/suda/login");
    }
  } finally {
    setLoading(false);
  }
};





  useEffect(() => { fetchZones();  }, []);

    useEffect(() => { fetchDistricts(1); }, [perPage]);



  //  ADD
  const openAddModal = () => {
    setShowModal(true);
    setIsEdit(false);
    setDistrictName("");
    setZoneId("");
  };

  //  EDIT
  const openEditModal = (row) => {
    setShowModal(true);
    setIsEdit(true);

    setEditId(row.id);
    setDistrictName(row.district_name);
    setZoneId(row.zone_id);
  };

  const handleSave = async () => {
    if(!districtName || !zoneId){
        Swal.fire("Validation Failed", "All Fields Are Required", "warning");
        return;
    }
  try {
const token = localStorage.getItem("token");

    const payload = {
      district_name: districtName,
      zone_id: Number(zoneId),
    };

    // ✅ IF EDIT → SEND ID
    if (isEdit && editId) {
      payload.id = editId;
    }

    await axios.post(
      `${BASE_URL}/districtMasterAddEdit`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    Swal.fire(
      isEdit ? "Updated!" : "Saved!",
      isEdit ? "District updated successfully" : "District added successfully",
      "success"
    );

    fetchDistricts(page, filters.searchKey);
    setShowModal(false);
  } catch (err) {
    console.error("Save Error:", err.response?.data || err);

    // 🔐 TOKEN EXPIRED
    if (err.response?.status === 401) {
      localStorage.clear();
      navigate("/suda/login");
      return;
    }

    // 🟡 VALIDATION / API ERROR
    Swal.fire({
      icon: "warning",
      title: "Error",
      text:
        err.response?.data?.message ||
        err.response?.data?.errors?.district_name?.[0] ||
        "Something went wrong",
      timer: 2000,
      showConfirmButton: false,
    });
  }
};


  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>

      <Card
  className="mb-4 border-0"
  style={{
    background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
    borderRadius: "14px",
    boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
  }}
>
  <div
    className="px-4 py-3 text-white rounded-top"
    style={{
      background: "linear-gradient(90deg, #0D47A1, #1565C1)",
    }}
  >
    <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
      <i className="fa-solid fa-filter"></i> District Master
    </h5>
  </div>

  <Card.Body className="px-4 py-4">
    <Row className="align-items-center">
      {/* ✅ SEARCH INPUT */}
      <Col md={4}>
        <Form.Group className="mb-3">
          <Form.Label className="fw-semibold text-dark">
            Search District
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter district..."
            value={filters.searchKey}
            onChange={(e) =>
              setFilters({ searchKey: e.target.value })
            }
            style={{
              borderRadius: "10px",
              border: "2px solid #1565C1",
            }}
          />
        </Form.Group>
      </Col>

      <Col md={4}>
      <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

          <Form.Select
           style={{
                          borderRadius: "10px",
                          border: "2px solid #1565C1",
                        }}
            value={perPage}
            onChange={(e) => {
              const value = Number(e.target.value);
              setPerPage(value);
              setPage(1);

            }}

          >
            <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
          </Form.Select>
          </Form.Group>
      </Col>

      {/* ✅ BUTTONS */}
      <Col md={4} className="d-flex gap-3 mt-3">
        {/* SEARCH */}
        <Button
          className="w-50 fw-semibold text-white"
          style={{
            background: "#1565C1",
            border: "none",
            borderRadius: "10px",
            transition: "0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
          onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
        onClick={() => fetchDistricts(1, filters.searchKey)}
        >
          <i className="fa-solid fa-magnifying-glass me-2"></i> Search
        </Button>

        {/* RESET */}
        <Button
  className="w-50 fw-semibold text-white"
  style={{
    background: "#E53935",
    border: "none",
    borderRadius: "10px",
    transition: "0.3s",
  }}
  onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
  onMouseLeave={(e) => (e.target.style.background = "#E53935")}
  onClick={() => {
    // reset filters and pagination
    setFilters({ searchKey: "" });
    setPage(1);
    setPerPage(10);

    // reload data with default params
    fetchDistricts(1, ""); // 🔹 Add this line
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
</Button>

      </Col>
    </Row>
  </Card.Body>
</Card>


      <Button
  className="mb-3 px-4 text-white fw-semibold"
  onClick={openAddModal}
  style={{
    background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
    border: "none",
    borderRadius: "10px",
    padding: "10px 22px",
    boxShadow: "0 6px 15px rgba(46,125,50,0.4)",
    transition: "0.3s",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.background =
      "linear-gradient(135deg, #1B5E20, #2E7D32)";
    e.currentTarget.style.transform = "translateY(-2px)";
    e.currentTarget.style.boxShadow =
      "0 10px 22px rgba(46,125,50,0.55)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.background =
      "linear-gradient(135deg, #2E7D32, #66BB6A)";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow =
      "0 6px 15px rgba(46,125,50,0.4)";
  }}
>
  <i className="fa-solid fa-circle-plus me-2"></i> Add District
</Button>



      {/*  TABLE */}
{loading && (
  <div className="loader-wrapper">
    <div className="blue-spinner"></div>

    <div className="loading-line">
      <div className="loading-progress"></div>
    </div>

    <p className="loading-text">Loading, please wait...</p>
  </div>
)}

{/* ✅ SHOW TABLE ONLY WHEN NOT LOADING */}
{!loading && (
  <Card
    className="mb-4 border-0"
    style={{
      background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
      boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
      overflow: "hidden",
    }}
  >
    <Table bordered hover responsive striped>
      <thead className="text-white">
        <tr>
          <th style={theadStyle}>SL</th>
          <th style={theadStyle}>District</th>
          <th style={theadStyle}>Zone</th>
          <th style={theadStyle}>Action</th>
        </tr>
      </thead>

      <tbody>
        {districts.length > 0 ? (
          districts.map((row, i) => (
            <tr
              key={row.id}
              style={{
                backgroundColor: i % 2 === 0 ? "#F5F9FF" : "white",
              }}
            >
              <td className="text-center">
          {(page - 1) * perPage + i + 1}
        </td>
              <td className="text-center">{row.district_name}</td>
              <td className="text-center">
                {row.zone_name || "—"}
              </td>

              <td className="text-center">
                <Button
                  size="sm"
                  className="me-2"
                  style={{
                    background: "#1565C1",
                    border: "none",
                  }}
                  onClick={() => openEditModal(row)}
                >
                  <i className="fa-solid fa-pen text-white"></i>
                </Button>

                <Button
                  size="sm"
                  style={{
                    background: "linear-gradient(90deg, #E53935, #D32F2F)",
                    border: "none",
                  }}
                 onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}

                >
                  <i className="fa-solid fa-trash-can text-white"></i>
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="4" className="text-center py-4">
              <span
                style={{
                  background: "#E3F2FD",
                  color: "#1565C1",
                  padding: "8px 20px",
                  borderRadius: "20px",
                  fontWeight: "600",
                }}
              >
                No Data Found
              </span>
            </td>
          </tr>
        )}
      </tbody>
    </Table>

   {
    totalPages > 1 && (
         <div className="d-flex justify-content-center mt-4">
        <nav>
            <ul className="pagination shadow-sm">

            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchDistricts(1)}>
                «
                </button>
            </li>

            {/* Prev */}
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchDistricts(page - 1)}>
                ‹
                </button>
            </li>

            {/* Page Numbers */}
            {getPageNumbers().map((p) => (
                <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                <button className="page-link" onClick={() => fetchDistricts(p)}>
                    {p}
                </button>
                </li>
            ))}

            {/* Next */}
            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchDistricts(page + 1)}>
                ›
                </button>
            </li>

            {/* Last */}
            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchDistricts(totalPages)}>
                »
                </button>
            </li>

            </ul>
        </nav>
    </div>
    )
   }

  </Card>
)}


      {/* 🟦 MODAL */}
      <Modal show={showModal} onHide={()=>setShowModal(false)} centered  backdrop="static"
  keyboard={false} >
        <Modal.Header closeButton style={{background:"#3399ff",color:"white"}}>
          <Modal.Title>{isEdit?"Edit District":"Add New District"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Select Zone <span className="text-danger">*</span></Form.Label>
            <Form.Select value={zoneId} onChange={(e)=>setZoneId(e.target.value)}>
              <option value="">-- Select Zone --</option>
              {zones.map(z=>(
                <option key={z.id} value={z.id}>{z.zone_name}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>District Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              value={districtName}
              placeholder="Enter district..."
              onChange={(e)=>setDistrictName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={()=>setShowModal(false)} className="btn btn-danger text-white">Cancel</Button>
          <Button className="btn-success text-white" onClick={handleSave}>
            {isEdit?"Update":"Submit"}
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

export default DistrictMaster;
